import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * GoogleTagTracker
 * Sikrer at Google Tag (GTM / gtag) registrerer page_view og virtuelle sidevisninger
 * på samtlige sider og undersider i appen ved både initial load og SPA route changes.
 */
export default function GoogleTagTracker() {
  const location = useLocation();
  const prevUrlRef = useRef(typeof window !== "undefined" ? window.location.href : "");
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];

    // Venter 80ms så react-helmet-async og DOM når at opdatere document.title
    const timer = setTimeout(() => {
      const pagePath = location.pathname + location.search + location.hash;
      const pageLocation = window.location.href;
      const pageTitle = document.title || "ET Danmark ApS";

      // 1. Standard Google Tag / GA4 page_view event
      window.dataLayer.push({
        event: "page_view",
        page_location: pageLocation,
        page_path: pagePath,
        page_title: pageTitle,
      });

      // 2. GTM SPA virtual_pageview event (anbefalet standard i GTM til Single Page Apps)
      window.dataLayer.push({
        event: "virtual_pageview",
        page_location: pageLocation,
        page_url: pageLocation,
        page_path: pagePath,
        page_title: pageTitle,
      });

      // 3. gtm.historyChange for standard GTM History Change triggers
      if (!isFirstRender.current && prevUrlRef.current !== pageLocation) {
        window.dataLayer.push({
          event: "gtm.historyChange",
          "gtm.oldUrl": prevUrlRef.current,
          "gtm.newUrl": pageLocation,
          "gtm.historyChangeSource": "pushState",
        });
      }

      prevUrlRef.current = pageLocation;
      isFirstRender.current = false;
    }, 80);

    return () => clearTimeout(timer);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
